module.exports = __webpack_public_path__ + "img/example-healthcare-zones.c256d0e1.png";